import { render, staticRenderFns } from "./NotificationSettingButton.vue?vue&type=template&id=cf6eeec4&scoped=true&"
import script from "./NotificationSettingButton.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettingButton.vue?vue&type=style&index=0&id=cf6eeec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6eeec4",
  null
  
)

export default component.exports